import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let BroadcastActions = class BroadcastActions extends Mixins(ViewportSizeMixin) {
    buttonText(text, cardAction) {
        if (this.xsOnly && cardAction) {
            return '';
        }
        return text;
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], BroadcastActions.prototype, "cardAction", void 0);
BroadcastActions = __decorate([
    Component({
        components: {
            ActionButton,
        },
        filters: {
            emptyText(value, cardAction, breakpoint) {
                if (breakpoint && cardAction) {
                    return '';
                }
                return value;
            },
        },
    })
], BroadcastActions);
export default BroadcastActions;
